export default (name) => {
  name = String(name).replace(/\./g, '###');

  return `_${name}`;
};
